module.exports = __webpack_public_path__ + "media/images/logo-footer-35ae71bb334c914683c295bf58a5efac.png";